import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData, API_URL } from '../../Api';

export default function TaroffOrderStateChangesReport(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        const queryString = {
            'token': localStorage.getItem('admin_auth_token'),
            'q-insert-time-from': filterQInsertTimeFrom,
            'q-insert-time-to': filterQInsertTimeTo,
            'q-old-state-id': filterQOldStateId,
            'q-new-state-id': filterQNewStateId,
        };
        const url =
            API_URL +
            '/api/panel/page/taroff-order-state-changes-report/export-excel?' +
            new URLSearchParams(queryString).toString();
        window.open(url, '_blank');
    };
    const [formQOldStateIdOptions, setFormQOldStateIdOptions] = useState([]);
    useEffect(() => {
        postData(
            '/api/panel/page/taroff-order-state-changes-report/select-data/q-old-state-id'
        ).then((response) => {
            setFormQOldStateIdOptions(response.data);
        });
    }, []);
    const [formQNewStateIdOptions, setFormQNewStateIdOptions] = useState([]);
    useEffect(() => {
        postData(
            '/api/panel/page/taroff-order-state-changes-report/select-data/q-new-state-id'
        ).then((response) => {
            setFormQNewStateIdOptions(response.data);
        });
    }, []);
    const handlecomp2 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQOldStateId('');
        setFilterQNewStateId('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQOldStateId && (newSearchParams['q-old-state-id'] = filterQOldStateId);
        filterQNewStateId && (newSearchParams['q-new-state-id'] = filterQNewStateId);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQOldStateId, setFilterQOldStateId] = useState(allProps['q-old-state-id'] || '');
    const [filterQNewStateId, setFilterQNewStateId] = useState(allProps['q-new-state-id'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-order-state-changes-report/table-data', {
            size: tableSize,
            page: tablePage,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_old_state_id: filterQOldStateId,
            q_new_state_id: filterQNewStateId,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>گزارش تغییر وضعیت ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        دریافت اکسل
                    </Button>
                </LeftComponents>
            </Row>
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج از'}
                value={filterQInsertTimeFrom}
                onChange={setFilterQInsertTimeFrom}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج تا'}
                value={filterQInsertTimeTo}
                onChange={setFilterQInsertTimeTo}
                width={'100px'}
            />
            <MultiSelectBox
                label={'وضعیت از'}
                options={formQOldStateIdOptions}
                value={filterQOldStateId}
                onChange={setFilterQOldStateId}
            />
            <MultiSelectBox
                label={'وضعیت به'}
                options={formQNewStateIdOptions}
                value={filterQNewStateId}
                onChange={setFilterQNewStateId}
            />
            <Button onClick={handlecomp2} color={'secondary'}>
                جستجو
            </Button>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>تعداد</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_order_id_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_cnt}</TextView>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
